import React, { useState,useEffect,useRef }  from 'react';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import { BrowserRouter as Router, useNavigate,useParams  } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Common,{Server,Server2,AlphabetOnly,NumericOnly,logoutButton,download,LoadingDialog,ErrorDialog,Topbar,CallAPI,GetData, ConsoleLog,Server3,CallDvrAPI,redirectToNew,emptyCache} from './commonfunction';

const DialogTitle = (props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography style={{
      margin: 0,
      padding: 15,
    }} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" style={{
          position: 'absolute',
          right: 2,
          top: 2,
          color: "#888888",
        }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};


function SignIn(props) {
  //const { id } = useParams();
  //ConsoleLog(id);
  let navigate = useNavigate();
  const [error, setError] = useState(false);
  const [errorNo, setErrorNo] = useState("400");
  const [status, setStatus] = useState(0);
  const [isLoaded, setIsLoaded] = useState(true);
  const [items, setItems] = useState([]);
  const [userName,setUserName] = useState("")
  const [password, setPassword] = useState("");
  const userRefs = useRef()
  const passwordRefs = useRef()
  const [message, setMessage] = useState("");
  const [selectedColor, setSelectedColor] = useState("Black");
  const colorMap = {0:"#000000",1:"#FF0000",2:"#FF7F00",3:"#FFFF00",4:"#00FF00",5:"#0000FF",6:"#4B0082",7:"#9400D3"}//0Black,1Red,2Orange,3Yellow,4Green,5Blue,,6Indigo,7Violet

  const rememberCheckBox = useRef()
  const [remember,setRemember] = useState(false)
  const [textFieldLayout, setTextFieldLayout] = useState([]);

  useEffect(
    () => {
      const interval = setTimeout(() => {
       
      }, 200);
      return () => clearTimeout(interval)
    }
  ,[]);//,[] make it run only once
  //MyComponent();
  //const [isLogIn,setLogin] = useState(false);

   //let history = useHistory();
   //key="somName" is important for useState to update value and put layout to <div></div>
   const handleUserNameChange = (event) => {
    setUserName(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleRememberChange = (event) => {
    setRemember(event.target.checked);
  };
   const loadingDialog = 
   <Dialog
     open={!isLoaded}
     onClose={null}
     aria-labelledby="alert-dialog-title"
     aria-describedby="alert-dialog-description"
   >
     <DialogTitle id="alert-dialog-title"><Typography align="center"  style={{width:200}}>Loading</Typography></DialogTitle>
     </Dialog>;

    const layout = [];
    layout.push(<TextField inputRef={userRefs} value={userName} variant="outlined" margin="normal" required fullWidth id="userfield" label="Login ID" name="userfield" key="userfieldKey" autoComplete="user" autoFocus style={{height:50}} onChange={handleUserNameChange}/>);
    layout.push(<TextField inputRef={passwordRefs} value={password} variant="outlined" margin="normal" required fullWidth name="passwordfield" key="passwordfieldKey" label="Password" type="password" id="passwordfield" autoComplete="current-password" style={{height:50}} onChange={handlePasswordChange}/>);
    //layout.push(<FormControlLabel control={<Checkbox checked={remember} inputRef={rememberCheckBox} name="rememberCheckBox" key="rememberCheckBoxKey" color="primary"/>} label="Save Login Information"  onChange={handleRememberChange}/>);
    return (

      <div style={{backgroundImage:'url("image/CityMotorsBackGround.png")',backgroundSize:'cover',backgroundRepeat:'no-repeat',height:'100vh',width:'100%',marginTop:'0vh',overflow:"scroll",msOverflowStyle:'none',scrollbarWidth:'none'}}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div style={{height:'96vh'}}>
              <div style={{height:85 , background:"#FFFFFF", width: '100%' }}>
                <img style={{height:85,marginTop:5}} src="image/CityMotors2.png"/>
              </div>
              <div style={{ paddingLeft:'1%',paddingRight:'1%',
                            display:'block', position: 'relative',
                            
                            width: '100%',
                            borderRadius: '10px',
                            overflow:"scroll",msOverflowStyle:'none',scrollbarWidth:'none',overflow: 'hidden'}}>
                  <div style={{fontSize:26,fontWeight:"bold",textAlign:"center",float:'left',marginTop:30,width: '100%',}}>
                    {'Student Attendance App'}
                  </div>
                  {layout}
                  <Button type="submit" fullWidth variant="contained" style={{color: "#FFFFFF",background: "#6677AA",height:50,marginTop:20}}
                    onClick={
                      ()=>{
                        // localStorage.setItem('LoginID_DvrCheck',userRefs.current.value);
                        // if(rememberCheckBox.current.checked){
                        //   localStorage.setItem('StAttAppLoginID',userRefs.current.value);
                        //   localStorage.setItem('StAttAppPassword',passwordRefs.current.value);
                        // }else{
                        //   localStorage.setItem('StAttAppLoginID',"");
                        //   localStorage.setItem('StAttAppPassword',"");
                        // }
                        //localStorage.setItem('IsRemember',rememberCheckBox.current.checked);
                        //localStorage.setItem('IMEI',id);
                        var para0 = JSON.stringify({UserID:userRefs.current.value,Password:passwordRefs.current.value,IMEI:"",System:"AttendApp"});
                        var para1 = "\{\"UserID\":\"Web_Test\",\"Password\":\"123\",\"IMEI\":\"0\",\"System\":\"Web\"\}";
                        var para2 = "action=Login";
                        var para3 = para2 + "&itemObject=" + para0;
                        var para4 = "action=Login&itemobject=%7B%22UserID%22%3A%22Web_Test%22%2C%22Password%22%3A%22123%22%2C%22IMEI%22%3A%220%22%2C%22System%22%3A%22Web%22%7D";
                        GetData(para3,
                            data => {
                              if(data["result"] === "200"){
                                localStorage.setItem('StAttApptoken',data["token"]);
                                navigate("/mainContent");
                              }else{
                                setErrorNo("400");
                                setError(true);
                              }
                            }
                          );
                      }
                    }
                  >
                    Sign In
                  </Button>

                  <div variant="body2" color="textSecondary" style={{marginTop:'1vh',height:'34vh'}}>{/*float:'bottom', */}
                    <div>
                    <Typography
                      variant="body1"
                      style={{color:colorMap[selectedColor],whiteSpace: 'pre-line',width:"99%",height:'24vh',overflow:"scroll",msOverflowStyle:'none',scrollbarWidth:'none'}}
                    >
                      {message}
                    </Typography>
                    </div>
                    <div style={{width:"99%",height:'10vh'}}>
                    <div>{'Email：csb@citymotors.com.hk'}</div>
                    <div>{'Office hour：10:00am – 6:00pm (Mon - Fri)'}</div>
                    </div>
                  </div>

              </div>
              {loadingDialog}
          </div>
        </Container>
        {ErrorDialog(errorNo,error,()=>{setError(false);})}
      </div>
      //   </Switch>
      //   <Route path="/tabs">
      //       <SimpleTabs />
      //     </Route>
      //     <Route path="/tabs2">
      //       <SimpleList />
      //     </Route>
      // </Router>
    );
}

function SignIn2(props) {
  const { id } = useParams();
  emptyCache();
  redirectToNew(id);
  // useEffect(
  //   () => {
  //     setTimeout(() => {
  //       if(true){//refreshCount >=30
  //         emptyCache();
  //         redirectToNew(id);
  //         //getAppUserLogin();
  //       }
  //     }, 1000);
  //   }
  // ,[]);//,[] make it run only once
}




export default SignIn;